import React from "react";
import { useTranslation } from "react-i18next";
import HeroSection from "../../components/common/HeroSection";
import PageShell from "../../components/common/PageShell";
import SectionHeader from "../../components/common/SectionHeader";
import ContactForm from "../../components/contact/ContactForm";
import UAEMap from "../../components/contact/UAEMap";
import { PAGE_HEROES } from "../../constants/pageHeroes";
import { CONTENT_WIDTH } from "../../utils/layout";

function Contact() {
  const { t } = useTranslation();

  return (
    <PageShell>
      <HeroSection {...PAGE_HEROES.contact} variant="page" />
      <section className="caf-section caf-section--elevated">
        <SectionHeader
          titleId="contact-body-title"
          eyebrow={t("Reach Us")}
          title={t("Contact Us")}
          subtitle={t("Always at your service and the goal is to always satisfy our customers")}
        />
        <div
          className={`${CONTENT_WIDTH} flex min-h-[50vh] flex-col items-stretch justify-center gap-8 py-4 md:flex-row md:items-start md:justify-center md:gap-10 md:py-8`}
        >
          <UAEMap />
          <ContactForm />
        </div>
      </section>
    </PageShell>
  );
}

export default Contact;
